
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"13","viewBox":"0 0 12 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#footer-email-svg)"}},[_c('path',{attrs:{"d":"M7.95508 6.5615L12.0006 9.119V3.896L7.95508 6.5615Z","fill":"#DDDDDD"}}),_c('path',{attrs:{"d":"M0 3.896V9.119L4.0455 6.5615L0 3.896Z","fill":"#DDDDDD"}}),_c('path',{attrs:{"d":"M11.2509 2.375H0.750937C0.376687 2.375 0.0796875 2.654 0.0234375 3.01325L6.00094 6.9515L11.9784 3.01325C11.9222 2.654 11.6252 2.375 11.2509 2.375Z","fill":"#DDDDDD"}}),_c('path',{attrs:{"d":"M7.26694 7.01467L6.20569 7.71367C6.14269 7.75492 6.07144 7.77517 5.99944 7.77517C5.92744 7.77517 5.85619 7.75492 5.79319 7.71367L4.73194 7.01392L0.0234375 9.99217C0.0811875 10.3484 0.376687 10.6252 0.749438 10.6252H11.2494C11.6222 10.6252 11.9177 10.3484 11.9754 9.99217L7.26694 7.01467Z","fill":"#DDDDDD"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"footer-email-svg"}},[_c('rect',{attrs:{"width":"12","height":"12","fill":"white","transform":"translate(0 0.5)"}})])])])
          )
        }
      }
    